import React, { useState } from 'react';

const updateCompany = async (companyData) => {
  let wsUrl = import.meta.env.VITE_REACT_APP_BACK_NODE_COMPANY_ENDPOINT;
  try {
    const response = await fetch(wsUrl, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(companyData)
    });

    if (response.ok) {
      let data = await response.json();
      console.log("response data : " + JSON.stringify(data));
      // Faites quelque chose avec les données renvoyées par le backend
    } else {
      let text = await response.text();
      console.log("error response text : " + text);
      // Faites quelque chose en cas d'erreur, comme afficher un message d'erreur
    }
  } catch (ex) {
    console.log("ex : " + ex);
    // Faites quelque chose en cas d'erreur générale, comme afficher un message d'erreur
  }
};

const CompanyUpdate = () => {
  const [formData, setFormData] = useState({
    id: "6473f87e3f01be0f9e5a9016",
    sirenNumber: "267500049",
    siretNumber: "26750004903464",
    name: "CENTRE D'ACTION SOCIALE DE LA VILLE DE PARIS RESTAURANT EMERAUDE ARAGO",
    address: "49 BD ARAGO",
    postcode: "",
    latitude: "48.834788",
    longitude: "2.345364",
    revenue: "",
    netProfit: ""
  });

  const handleChange = (event) => {
    setFormData({ ...formData, [event.target.name]: event.target.value });
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    updateCompany(formData);
  };

  return (
    <div>
      <h1>Company Update</h1>
      <form onSubmit={handleSubmit}>
        <label>
          ID:
          <input type="text" name="id" value={formData.id} onChange={handleChange} />
        </label>
        <br />
        <label>
          SIREN Number:
          <input type="text" name="sirenNumber" value={formData.sirenNumber} onChange={handleChange} />
        </label>
        <br />
        <label>
          SIRET Number:
          <input type="text" name="siretNumber" value={formData.siretNumber} onChange={handleChange} />
        </label>
        <br />
        <label>
          Name:
          <input type="text" name="name" value={formData.name} onChange={handleChange} />
        </label>
        <br />
        <label>
          Address:
          <input type="text" name="address" value={formData.address} onChange={handleChange} />
        </label>
        <br />
        <label>
          Postcode:
          <input type="text" name="postcode" value={formData.postcode} onChange={handleChange} />
        </label>
        <br />
        <label>
          Latitude:
          <input type="text" name="lat" value={formData.latitude} onChange={handleChange} />
        </label>
        <br />
        <label>
          Longitude:
          <input type="text" name="lon" value={formData.longitude} onChange={handleChange} />
        </label>
        <br />
        <label>
          Revenue:
          < input type="text" name="revenue" value={formData.revenue} onChange={handleChange} />
        </label>
        <br />
        <label>
          Net Profit:
          <input type="text" name="netProfit" value={formData.netProfit} onChange={handleChange} />
        </label>
        <br/>
        <button type="submit">Update</button>
      </form>
    </div>
  );
};

export default CompanyUpdate;
